export default "__VITE_ASSET__DH0VmqD9__"